import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {addGlobalError} from "../../../../actions/globalerror";

class Rings extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        setEditMode: PropTypes.func.isRequired,
        updateRow: PropTypes.func.isRequired,
        deleteRow: PropTypes.func.isRequired,
        acceptRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
        };
    }

    fields = [];
    render() {
        return <div>
            <table className="data-table">
                <thead>
                <tr>
                    <th></th>
                    <th>Fejltekst</th>
                    <th className="center">Foren</th>
                    <th className="center">Slag</th>
                    <th className="center">År</th>
                    <th className="center">Fra</th>
                    <th className="center">Til</th>
                    <th className="center">Suppl</th>
                    <th>Vers.</th>
                </tr>
                </thead>
                <tbody>
                {this.props.data.map((row, ix) => ix === this.state.editIx ? <tr key={ix} className="edit-row">
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className="fa fa-save clickable" title="Gem station" onClick={() => {
                            if (this.allInputValid()) {
                                this.props.updateRow({
                                    Nr: row.Nr,
                                }, {
                                    Foreningsnr: this.state.Foreningsnr === '' ? null : this.state.Foreningsnr,
                                    Slag: this.state.Slag === '' ? null : this.state.Slag,
                                    Aar: this.state.Aar === '' ? null : this.state.Aar,
                                    Fra: this.state.Fra === '' ? null : this.state.Fra,
                                    Til: this.state.Til === '' ? null : this.state.Til,
                                    Supplerende: this.state.Supplerende,
                                }, () => {
                                    NotificationManager.success("Ringserien " + this.state.Fra + "-" + this.state.Til + " for slag " + this.state.Slag + " i forening " + this.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                    this.setState({editIx: null});
                                    this.props.setEditMode(false);
                                });
                            } else {
                                this.fields.forEach((field) => {
                                    field.setState({visited: true});
                                });
                            }
                        }}/>
                        <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                            this.setState({editIx: null});
                            this.props.setEditMode(false);
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[0] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Slag" id="Slag" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slag}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[1] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Aar" id="Aar" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.Aar}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[2] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field75" containerClassName="display-inline-block"
                                          name="Fra" id="Fra" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Fra}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[3] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field75" containerClassName="display-inline-block"
                                          name="Til" id="Til" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Til}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[4] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <input type="checkbox" name="Supplerende" id="Supplerende" checked={this.state.Supplerende === 'X' || this.state.Supplerende === 'x'} onChange={(e) => {
                            this.setState({Supplerende: e.target.checked ? 'X' : null});
                        }}/>
                    </td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr> : <tr key={ix}>
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                            if (this.state.editIx === null) this.setState({
                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                Slag: row.Slag === null ? '' : row.Slag,
                                Aar: row.Aar === null ? '' : row.Aar,
                                Fra: row.Fra === null ? '' : row.Fra,
                                Til: row.Til === null ? '' : row.Til,
                                editIx: ix,
                            });
                            this.props.setEditMode(true);
                        }}/>
                        <i className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet række" onClick={() => {
                            if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette ringserien <b>{row.Fra}-{row.Til}</b> for slag <b>{row.Slag}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.deleteRow([{
                                    Nr: row.Nr,
                                }], () => {
                                    NotificationManager.success("Ringserien " + row.Fra + "-" + row.Til + " for slag " + row.Slag + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                });
                            });
                        }}/>
                        <i className={"fa fa-check " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Accepter række" onClick={() => {
                            if (this.state.editIx === null) confirm("Accepter", <span>Ønsker du at acceptere ringserien <b>{row.Fra}-{row.Til}</b> for slag <b>{row.Slag}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.acceptRow([{
                                    Nr: row.Nr,
                                }], (response) => {
                                    if (response.failed.length > 0) this.props.dispatch(addGlobalError('Fejl ved accept', response.failed[0].msg, -1));
                                    else NotificationManager.success("Ringserien " + row.Fra + "-" + row.Til + " for slag " + row.Slag + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                });
                            });
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">{row.Foreningsnr === null ? '' : row.Foreningsnr}</td>
                    <td className="center">{row.Slag === null ? '' : row.Slag}</td>
                    <td className="center">{row.Aar === null ? '' : row.Aar}</td>
                    <td className="center">{row.Fra === null ? '' : row.Fra}</td>
                    <td className="center">{row.Til === null ? '' : row.Til}</td>
                    <td className="center">{row.Supplerende === null ? '' : row.Supplerende}</td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr>)}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Nr: row.Nr,
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null, null, {withRef: true})(Rings);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Rings.js